var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFire = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.367 6.76c-.015-.208-.314-.314-.428-.14-2.93 4.473-.456 6.614.925 7.392.184.104.349-.127.237-.307-.752-1.213-.412-2.476-.05-3.128.073-.131.255-.11.33.02.355.62.774.825 1.042.89.132.033.215-.099.168-.227-.505-1.383-.064-2.99 1.021-3.831.135-.105.317.023.311.194-.058 1.631 1.52 2.834 1.703 3.943.108.661-.04 1.297-.235 1.796-.082.21.176.43.335.272.75-.75 1.705-2.036 1.705-3.726 0-3.049-3.614-4.311-3.296-7.8.017-.178-.186-.306-.328-.196C6.392 3.772 5.724 5.88 5.91 7.56c.024.221-.245.343-.328.137a3 3 0 0 1-.215-.936"
})));
export { SvgFire as ReactComponent };